import { useEffect, useState } from "react";

export const PRIVACY_PREFERENCE_VERSION = "2026-09";
export const PRIVACY_STORAGE_KEY = "cc_privacy_preferences";
export const PRIVACY_PREFERENCE_EVENT = "competition-checker:privacy-change";

export const DEFAULT_PRIVACY_PREFERENCES = Object.freeze({
  service_analytics: false,
  advertising_personalisation: false,
});

const normalise = (value = {}) => ({
  service_analytics: value.service_analytics === true,
  advertising_personalisation: value.advertising_personalisation === true,
});

export function readPrivacyPreferences() {
  if (typeof window === "undefined") return { ...DEFAULT_PRIVACY_PREFERENCES };
  try {
    const stored = JSON.parse(window.localStorage.getItem(PRIVACY_STORAGE_KEY) || "null");
    if (!stored || stored.version !== PRIVACY_PREFERENCE_VERSION) {
      return { ...DEFAULT_PRIVACY_PREFERENCES };
    }
    return normalise(stored.preferences);
  } catch (_error) {
    return { ...DEFAULT_PRIVACY_PREFERENCES };
  }
}

export function writePrivacyPreferences(value) {
  const preferences = normalise(value);
  if (typeof window !== "undefined") {
    window.localStorage.setItem(
      PRIVACY_STORAGE_KEY,
      JSON.stringify({ version: PRIVACY_PREFERENCE_VERSION, preferences })
    );
    window.dispatchEvent(
      new CustomEvent(PRIVACY_PREFERENCE_EVENT, { detail: preferences })
    );
  }
  return preferences;
}

export function usePrivacyPreferences() {
  const [preferences, setPreferences] = useState(readPrivacyPreferences);
  useEffect(() => {
    const update = (event) => {
      setPreferences(normalise(event.detail || readPrivacyPreferences()));
    };
    window.addEventListener(PRIVACY_PREFERENCE_EVENT, update);
    window.addEventListener("storage", update);
    return () => {
      window.removeEventListener(PRIVACY_PREFERENCE_EVENT, update);
      window.removeEventListener("storage", update);
    };
  }, []);
  return preferences;
}
